<div class="modal-header">
  <h4 class="text-info" id="exampleModalLongTitle">
    Next Available Date Of Groomer
    <span class="modal-title-description h6 d-block text-default">You can select any dates given below to
      continue with this Groomer</span>
  </h4>
  <button type="button" class="close btn-close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body main-modal">
  <div class="plan-section plan-groomer-section">
    <div class="plan-list">
      <div class="row">
        <div class="col-12">
          <div class="plan-inner-box shadow-box">
            <div class="d-flex align-items-center mb-4 me-4">
              <div class="img-box">
                @if (previousGroomer?.groomer?.avatar) {
                <img [src]="imagePath + previousGroomer?.groomer?.avatar" alt="groomer img" />
                }@else {
                <ngx-avatars bgColor="{{ avatar_bg_color }}" fgColor="{{ avatar_fg_color }}" size="70" name="{{
                    previousGroomer?.groomer?.first_name +
                      ' ' +
                      previousGroomer?.groomer?.last_name
                  }}" textSizeRatio="2">
                </ngx-avatars>
                }
              </div>

              <h5>
                {{
                previousGroomer?.groomer?.first_name +
                " " +
                previousGroomer?.groomer?.last_name | titlecase
                }}
              </h5>
            </div>
            <div>
              <div class="title-block">
                <span class="text-info">Available Days:</span>
                {{ previousGroomer?.groomer?.reporting_time | titlecase }}
              </div>
              <ul class="avail-day d-flex flex-wrap gap-1">
                @for (day of previousGroomer?.groomer?.working_days; track
                $index) {
                <li>
                  <span class="day-item">{{ day }}</span>
                </li>
                }
              </ul>
            </div>
            <hr />
            <div>
              <div class="title-block">
                <span class="text-info">Available Dates:</span>
              </div>
              @if (previousGroomerAvailableDates?.length) {
              <ul class="avail-day d-flex flex-wrap date-list">
                @for (date of previousGroomerAvailableDates; track $index) {
                <li class="select-chip-item mb-2 cursor-pointer" [ngClass]="{
                    'bg-success': date == previousGroomerSelectedDate
                  }" (click)="onPreviousGroomerDateSelect(date)">
                  <span class="select-chip-text">{{
                    date | date : "MMM d"
                    }}</span>
                </li>
                }
              </ul>
              <!--  <div class="add-note-text mt-2">
                <span class="add-text text-secondary link cursor-pointer" (click)="loadMoreAvailableDate()">View More
                  dates</span>
              </div> -->
              }@else{
              <span class="d-flex justify-content-center">No any Dates</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="OnPreviousGroomerContinue()" [disabled]="
      !previousGroomerSelectedDate || previousGroomerAvailableDates?.length == 0
    ">
    <span>Continue</span>
  </button>
</div>